/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { usePolicyId } from '@pages/PolicyDetailPage/provider';

import { CANCEL_POLICY } from '@pages/PolicyDetailPage/apis/graphql';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@/config/apiConfig';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ICancelPolicyMethods extends IPluginMethodMap {
  getCancelPolicyStatus(args: any): Promise<any>;
}

export interface CancelPolicyProps {
  comments: string;
}

export class CancelPolicyPlugin implements IAgentPlugin {
  readonly methods: ICancelPolicyMethods;

  constructor() {
    this.methods = {
      getCancelPolicyStatus: this.getCancelPolicyStatus.bind(this),
    };
  }

  async getCancelPolicyStatus(args: CancelPolicyProps) {
    return await this.cancelPolicy(args);
  }

  private async cancelPolicy(args: any) {
    const { policyNumber } = usePolicyId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(CANCEL_POLICY, {
          policyId: policyNumber,
          reason: args?.comments,
        })
        .toPromise();
      if (res?.data?.cancelPolicy) {
        return res?.data?.cancelPolicy;
      }
    } catch (err: any) {
      throw err;
    }
  }
}
